import { StackToSend } from "./StackToSend";

export const pending = <T extends (...args: any[]) => Promise<any>>(
  func: T,
  compressStack?: (stack: Array<Parameters<T>>) => Parameters<T> | undefined,
  betweenDelay: number = 10,
): ((...args: Parameters<T>) => Promise<void>) => {
  const stackToSendInstance = new StackToSend(func, compressStack, betweenDelay);
  return stackToSendInstance.send;
};
